import React from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { useReservationInfo } from '../../context/ReservationContext'
import { HasPermission } from 'src/helper/HasPermission'
import { VOUCHER_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { PERMISSION_SHOW } from 'src/helper/Permission'

export const BillingAutomaticField = () => {
  const record = useRecordContext()
  const { reservationInfo } = useReservationInfo()
  const translate = useTranslate()

  const getBillingAutomatic = (hash) => {
    try {
      if (hash) {
        return reservationInfo?.billing_info?.[hash]?.automatic ? true : false
      }
    } catch (error) {
      return false
    }
  }
  return (
    <HasPermission permission={PERMISSION_SHOW} resource={VOUCHER_PERMISSION_ENTITY}>
      <ShowElement
        data={getBillingAutomatic(record?.hash_)}
        label={translate('ra.field.billing_automatic')}
        boolean={true}
      />
    </HasPermission>
  )
}
